import { Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  MatChipGrid,
  MatChipInput,
  type MatChipInputEvent,
  MatChipRemove,
  MatChipRow,
} from '@angular/material/chips';
import { type AbstractControl, type FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { MatIcon } from '@angular/material/icon';
import { ControlErrorComponent } from '@pct-ng/form';
import { AbstractFormFragmentComponent } from './abstract-form-fragment.component';
import { WithLangPipe } from '../../pipes/name-with-lang.pipe';
import type { LanguageCode } from '../../model/language-code';

interface TagsAndCtaForm {
  labels: FormControl<string[] | null>;
  ctaText: FormControl<string | null>;
  ctaUrl: FormControl<string | null>;
  [key: string]: AbstractControl<any, any>;
}

@Component({
  selector: 'cappus-tags-and-cta-form-fragment',
  imports: [
    TranslocoDirective,
    MatFormField,
    MatLabel,
    MatChipGrid,
    ReactiveFormsModule,
    MatChipRow,
    CustomMatSvgIconDirective,
    MatChipInput,
    MatIcon,
    MatInput,
    ControlErrorComponent,
    MatChipRemove,
    WithLangPipe,
  ],
  templateUrl: './tags-and-cta-form-fragment.component.html',
  host: {
    class: 'block w-full',
  },
})
export class TagsAndCtaFormFragmentComponent<
  FORM extends TagsAndCtaForm = TagsAndCtaForm,
> extends AbstractFormFragmentComponent<FORM> {
  readonly selectedLanguage = input.required<LanguageCode>();

  protected removeReactiveKeyword(keyword: string): void {
    const labelsControl = this.parentForm().controls.labels;
    const labels = labelsControl.value;
    const index = labels?.findIndex((c: any) => c === keyword);
    if (index !== undefined && index > -1) {
      labels?.splice(index, 1);
      labelsControl.setValue([...(labels ?? [])]);
    }
  }

  protected addReactiveKeyword(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const labelsControl = this.parentForm().controls.labels;

    if (value.length > 0) {
      labelsControl.setValue([...(labelsControl?.value ?? []), value]);
    }

    // Clear the input value
    event.chipInput?.clear();
  }
}
